module.exports = __webpack_public_path__ + "media/fr.0d678e25.mp3";